export const PREVIEW_FOLDER_PATH = "screenshots/"
export const SEGMENT_IMAGES_FOLDER_PATH = "images/"
export const PREVIEW_SEGMENT_PREFIX = "segmentpreview"
export const SEGMENT_IMAGE_FILE_NAME_REFIX = "part"
export const PREVIEW_CANVAS_NAME = "preview"
export const PREVIEW_CANVAS_EXTENSION = ".jpeg"
export const ADD_TO_CART_IFRAME_ACTION = "addToCartAction"
